import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { Moon } from 'lucide-react';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<'terms' | 'privacy'>('terms');
  const openModal = (type: 'terms' | 'privacy') => {
    setModalContent(type);
    setModalOpen(true);
  };
  return <footer className="bg-white py-12 border-t border-mint-100" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center" data-id="element-42">
        <div className="flex items-center justify-center mb-6" data-id="element-43">
          <Moon className="w-6 h-6 text-mint-600 mr-2" data-id="element-44" />
          <p className="font-bold text-lg text-gray-800 uppercase tracking-tight" data-id="element-45">
            Dormir Sin Pensar
          </p>
        </div>

        <div className="flex justify-center space-x-8 mb-8" data-id="element-46">
          <button onClick={() => openModal('terms')} className="text-gray-500 hover:text-mint-600 text-sm transition-colors underline" data-id="element-47">
            Términos de Uso
          </button>
          <button onClick={() => openModal('privacy')} className="text-gray-500 hover:text-mint-600 text-sm transition-colors underline" data-id="element-48">
            Política de Privacidad
          </button>
        </div>

        <p className="text-gray-400 text-xs" data-id="element-49">
          © {new Date().getFullYear()} Dormir Sin Pensar. Todos los derechos
          reservados.
        </p>
      </div>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={modalContent === 'terms' ? 'Términos de Uso' : 'Política de Privacidad'} data-id="element-50">
        {modalContent === 'terms' ? <div className="space-y-4 text-gray-600" data-id="element-51">
            <p data-id="element-52">
              Bienvenido a Dormir Sin Pensar. Al utilizar nuestro sitio web y
              adquirir nuestros productos digitales, aceptas los siguientes
              términos y condiciones.
            </p>
            <h3 className="text-lg font-bold text-gray-800 mt-4" data-id="element-53">
              1. Uso del Contenido
            </h3>
            <p data-id="element-54">
              Todo el contenido proporcionado en este ebook es para fines
              informativos y educativos únicamente. No sustituye el consejo
              médico profesional.
            </p>
            <h3 className="text-lg font-bold text-gray-800 mt-4" data-id="element-55">
              2. Propiedad Intelectual
            </h3>
            <p data-id="element-56">
              El contenido de "Dormir Sin Pensar" está protegido por derechos de
              autor. No está permitida su reproducción o distribución sin
              autorización.
            </p>
            <h3 className="text-lg font-bold text-gray-800 mt-4" data-id="element-57">
              3. Reembolsos
            </h3>
            <p data-id="element-58">
              Debido a la naturaleza digital del producto, por favor contáctenos
              si tiene problemas con su descarga.
            </p>
          </div> : <div className="space-y-4 text-gray-600" data-id="element-59">
            <p data-id="element-60">
              En Dormir Sin Pensar, nos tomamos muy en serio su privacidad. Esta
              política describe cómo recopilamos y utilizamos su información.
            </p>
            <h3 className="text-lg font-bold text-gray-800 mt-4" data-id="element-61">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-62">
              Recopilamos información básica necesaria para procesar su pedido,
              como su nombre y dirección de correo electrónico.
            </p>
            <h3 className="text-lg font-bold text-gray-800 mt-4" data-id="element-63">
              2. Uso de la Información
            </h3>
            <p data-id="element-64">
              Utilizamos su información únicamente para entregar el producto
              digital y enviarle actualizaciones relacionadas.
            </p>
            <h3 className="text-lg font-bold text-gray-800 mt-4" data-id="element-65">
              3. Seguridad
            </h3>
            <p data-id="element-66">
              Implementamos medidas de seguridad estándar para proteger su
              información personal.
            </p>
          </div>}
      </Modal>
    </footer>;
}